import Login from "./Login";
import Dashboard from "./Dashboard";
import NotFoundPage from "./NotFoundPage";
import ContractTypes from "./ContractTypes";
import VehicleTypes from "./VehicleTypes";
import BodyTypes from "./BodyTypes";
import ApplicationTypes from "./ApplicationTypes";
import MechanicalConditions from "./MechanicalConditions";

import MechanicalConditionsReasons from "components/mechanical-condition-reasons";
import VehicleMakeMaster from "components/vehicle-make-masters";
import VehicleModelMaster from "components/vehicle-model-masters";
import VehicleConfigurationMaster from "components/vehicle-configuration-masters";
import TyreReplacementReason from "components/tyre-replacement-reason";
import ScrapReason from "components/scrap-reason";
import TyreLocation from "components/tyre-locations";
import InspectionObservation from "components/inspection-observation";
import InspectionActionable from "components/inspection-actionable";
import ScrappingCasingDashboard from "./ScrappingCasingDashboard";

import Users from "./Users";
import Vehicles from "./Vehicles";
import Log from "./logs";
import LogViewer from "./mailLogger";
import Permissions from "./Permissions";
import InspectionPendingOver90Days from "./InspectionPendingOver90Days";
import InspectionDetailsInLastFourMonths from "./InspectionDetailsInLastFourMonths";
import ScrapAnalysis from "./ScrapAnalysis";
import CPKMTrendReport from "./CPKMTrendReport";
import CPKMUpload from "./CPKMUpload";
import GrnStatusLastFourMonths from "./GrnStatusLastFourMonths";
import GrnRejectStatusLastFourMonthsFleetWise from "./GrnRejectStatusLastFourMonthsFleetWise";
import VehicleEnrollmentDetails from "./VehicleEnrollmentDetails";
import WheelAlignmentInLastFourMonths from "./WheelAlignmentInLastFourMonths";
import FleetStockDetails from "./FleetStockDetails";
import SoldAndCasingReport from "./SoldAndCasingReport";
import InspectionReport from "./InspectionReport";
import AddTyre from "./AddTyre";
import StockTransfer from "./StockTransfer";
import StockTansferHistory from "./StockTransferHistory";
import OnWheelStencils from "./OnWheelStencils";
import AllStencils from "./AllStencils";
import DailyStencilDetails from "./DailyStencilDetail";

import ProductMaster from "components/product-master";
import SizeMaster from "components/size-master";
import CompanyMaster from "components/company-master";
import FleetHubMappingMaster from "components/fleet-hub-mapping-master";
import IGRNApproval from "./IGRNApproval";
import TWCIssues from "./TWCIssues";
import EmailAlerts from "./EmailAlerts";
import DailyInspectionReport from "./DailyInspectionReport";
import DailyFMGrnReport from "./DailyFMGrnReport";
import CasingTypes from "./casingTypes";
import TyreValidationReport from "./TyreValidationReport";
import VehicleDeEnrollmentReport from "./vehicleDeEnrollmentReport";
import CreateDeEnrollment from "components/vehicle-deenrollment/CreateDeEnrollment";
import wheelAlignmentReport from "./wheelAlignmentReport";
import TrainingMaterial from "./TrainingMaterials";
import DTPDiscussionPoints from "./DTPDiscussionPoints";
import DTPPlanning from "./DTPPlanning";
import ManageDTP from "./ManageDTP";
import ExternalStockTransferHistory from "./ExternalStockTransferHistory";
import ExternalStockTransferReport from "./ExternalStockTransferReport";
import AlignmentCenters from "./alignmentCenters";
import MobilityDashboard from "./MobilityDashboard";
import AgreedCPKM from "./AgreedCPKM";
import AlignmentPending from "./AlignmentPending";
import RotationPending from "./RotationPending";
import DailyTyreReplacement from "./DailyTyreReplacement";
import MonthWiseTyreTrendReport from "./MonthWiseTyreTrendReport";
import GrnPendingReport from "./GrnPendingReport";
import BatchWiseReport from "./BatchWiseReport";
import ContractMasters from "./ContractMaster";
import ContractMaster from "./ContractMaster";
import MechanicalIssueReport from "./MechanicalIssueReport";
import VendorMaster from "components/vendor-master";
import RetreadApprovel from "./RetreadApproval";
import RetreadApprove from "./RetreadRequests";
import VehicleFleetReport from "./VehicleFleetReport";
import { SyncMaster } from "./SyncMasters";
import PrivacyPolicy from "./PrivacyPolicy";
import Disclaimer from "./Disclaimer";
import MaterialMaster from "../components/material-master";
import { useSelector } from "react-redux";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";

/** Blocks access when user has only view_fleet_master (no view_masters/manage_masters). Use for all master pages except Fleet Master. */
const withMasterRouteGuard = (PageComponent) => {
  console.log("permissions.view_fleet_master", permissions.view_fleet_master);
  return function MasterRouteGuard(props) {
    const currentUser = useSelector((state) => state.user.currentUser);
    if (!currentUser) return null;
    const hasOnlyFleetMaster =
      checkPermission([permissions.view_fleet_master], currentUser) &&
      !checkPermission(
        [permissions.view_masters, permissions.manage_masters],
        currentUser,
      );
    if (hasOnlyFleetMaster) return <NotFoundPage />;
    return <PageComponent {...props} />;
  };
};

const pages = [
  {
    auth: true,
    path: "/email-alerts",
    main: EmailAlerts,
    moduleName: "Email Alerts",
  },
  {
    auth: false,
    path: "/",
    main: Login,
    moduleName: "Login",
  },
  {
    auth: true,
    path: "/dashboard",
    main: Dashboard,
    moduleName: "Fleet Operations",
  },
  {
    auth: true,
    path: "/mobility-dashboard",
    main: MobilityDashboard,
    moduleName: "Mobility Technical",
  },
  {
    auth: true,
    path: "/scrap-dashboard",
    main: ScrappingCasingDashboard,
    moduleName: "Scrap and Casing Tyres",
  },
  // {
  //   auth: true,
  //   path: "/stock-transfer/:id",
  //   main: ExternalStockTransferHistory,
  // },
  {
    auth: true,
    path: "/users",
    main: Users,
    moduleName: "Users",
  },
  {
    auth: false,
    path: "/login",
    main: Login,
    moduleName: "Login",
  },
  {
    auth: true,
    path: "/stock-transfer-history",
    main: StockTansferHistory,
    moduleName: "Stock Transfer History",
  },
  {
    auth: true,
    path: "/logs",
    main: Log,
    moduleName: "Change Log",
  },
  {
    auth: true,
    path: "/permisssions",
    main: Permissions,
    moduleName: "Roles & Permissions",
  },
  {
    auth: true,
    path: "/twc-issues",
    main: TWCIssues,
    moduleName: "TWC Issues",
  },
  {
    auth: true,
    path: "/igrn-approval",
    main: IGRNApproval,
    moduleName: "IGRN Approval",
  },
  {
    auth: true,
    path: "/retread-approval/:requestId",
    main: RetreadApprovel,
    moduleName: "Retread Approval",
  },
  {
    auth: true,
    path: "/vehicles",
    main: Vehicles,
    moduleName: "Vehicles",
  },

  {
    auth: true,
    path: "/mail-logger",
    main: LogViewer,
    moduleName: "Download Section",
  },

  {
    auth: true,
    path: "/tyres",
    main: AddTyre,
    moduleName: "Non CPKM Tyres",
  },
  {
    auth: true,
    path: "/stock-transfer",
    main: ExternalStockTransferHistory,
    moduleName: "Stock Transfers",
  },
  {
    auth: true,
    path: "/retread-requests",
    main: RetreadApprove,
    moduleName: "Retread Requests",
  },
  {
    auth: true,
    path: "/external-stock-transfers",
    main: ExternalStockTransferReport,
    moduleName: "Stock Transfer Report",
  },
  {
    auth: true,
    path: "/create-stock-transfer-request",
    main: StockTransfer,
    moduleName: "Create Stock Transfer",
  },
  {
    auth: true,
    path: "/contract-types",
    main: withMasterRouteGuard(ContractTypes),
    moduleName: "Contract Types",
  },
  {
    auth: true,
    path: "/contract-master",
    main: withMasterRouteGuard(ContractMaster),
    moduleName: "Contract Master",
  },
  {
    auth: true,
    path: "/vehicle-types",
    main: withMasterRouteGuard(VehicleTypes),
    moduleName: "Vehicle Types",
  },
  {
    auth: true,
    path: "/body-types",
    main: withMasterRouteGuard(BodyTypes),
    moduleName: "Body Types",
  },
  {
    auth: true,
    path: "/application-types",
    main: withMasterRouteGuard(ApplicationTypes),
    moduleName: "Application Types",
  },

  {
    auth: true,
    path: "/mechanical-conditions",
    main: withMasterRouteGuard(MechanicalConditions),
    moduleName: "Mechanical Conditions",
  },
  {
    auth: true,
    path: "/mechanical-conditions-reasons-master",
    main: withMasterRouteGuard(MechanicalConditionsReasons),
    moduleName: "Mechanical Conditions Reasons",
  },
  {
    auth: true,
    path: "/vehicle-make-master",
    main: withMasterRouteGuard(VehicleMakeMaster),
    moduleName: "Vehicle Make",
  },
  {
    auth: true,
    path: "/vehicle-model-master",
    main: withMasterRouteGuard(VehicleModelMaster),
    moduleName: "Vehicle Model",
  },
  {
    auth: true,
    path: "/vehicle-configuration-master",
    main: withMasterRouteGuard(VehicleConfigurationMaster),
    moduleName: "Vehicle Configuration",
  },

  {
    auth: true,
    path: "/tyre-replacement-reason",
    main: withMasterRouteGuard(TyreReplacementReason),
    moduleName: "Replacement Reasons",
  },
  {
    auth: true,
    path: "/alignment-center",
    main: withMasterRouteGuard(AlignmentCenters),
    moduleName: "Alignment Centers",
  },
  {
    auth: true,
    path: "/scrap-reason",
    main: withMasterRouteGuard(ScrapReason),
    moduleName: "Scrap Reasons",
  },
  {
    auth: true,
    path: "/tyre-locations",
    main: withMasterRouteGuard(TyreLocation),
    moduleName: "Tyre Locations",
  },
  {
    auth: true,
    path: "/casing-types",
    main: withMasterRouteGuard(CasingTypes),
    moduleName: "Casing Types",
  },
  {
    auth: true,
    path: "/inspection-actionable",
    main: withMasterRouteGuard(InspectionActionable),
    moduleName: "Inspection Actionables",
  },
  {
    auth: true,
    path: "/inspection-observation",
    main: withMasterRouteGuard(InspectionObservation),
    moduleName: "Inspection Observations",
  },
  {
    auth: true,
    path: "/inspectionPendingOver90Days",
    main: InspectionPendingOver90Days,
    moduleName: "Inspection Pending",
  },
  {
    auth: true,
    path: "/inspection-summary",
    main: InspectionDetailsInLastFourMonths,
    moduleName: "Inspection Trend",
  },
  {
    auth: true,
    path: "/scrap-analysis",
    main: ScrapAnalysis,
    moduleName: "Scrap Analysis",
  },
  {
    auth: true,
    path: "/vehicle-fleet-report",
    main: VehicleFleetReport,
    moduleName: "Fleet Inspection History Report",
  },
  {
    auth: true,
    path: "/cpkm-trend-report",
    main: CPKMTrendReport,
    moduleName: "CPKM Trend Report",
  },
  {
    auth: true,
    path: "/cpkm-upload",
    main: CPKMUpload,
    moduleName: "CPKM Upload",
  },
  {
    auth: true,
    path: "/month-wise-tyre-trend-report",
    main: MonthWiseTyreTrendReport,
    moduleName: "Month Wise Tyre Supply Trend",
  },
  {
    auth: true,
    path: "/grnStatusLastFourMonths",
    main: GrnStatusLastFourMonths,
    moduleName: "GRN Status",
  },
  {
    auth: true,
    path: "/grnRejectStatusLastFourMonthsFleetWise",
    main: GrnRejectStatusLastFourMonthsFleetWise,
    moduleName: "GRN Rejected Region Wise",
  },
  {
    auth: true,
    path: "/vehicleEnrollmentDetails",
    main: VehicleEnrollmentDetails,
    moduleName: "Vehicle Enrolment Details",
  },
  {
    auth: true,
    path: "/wheelAlignmentInLastFourMonths",
    main: WheelAlignmentInLastFourMonths,
    moduleName: "Wheel Alignment Summary",
  },
  {
    auth: true,
    path: "/wheelAlignmentReport",
    main: wheelAlignmentReport,
    moduleName: "Wheel Alignment Report",
  },
  {
    auth: true,
    path: "/fleetStockDetails",
    main: FleetStockDetails,
    moduleName: "Fleet Wise Stock Details",
  },
  {
    auth: true,
    path: "/soldAndCasingReport",
    main: SoldAndCasingReport,
    moduleName: "Casing And Sold Report",
  },
  {
    auth: true,
    path: "/inspection-report",
    main: InspectionReport,
    moduleName: "Inspection Report",
  },
  // {
  //   auth: true,
  //   path: "/create-de-enrollment",
  //   main: CreateDeEnrollment,
  // },

  {
    auth: true,
    path: "/tyre-validation-report",
    main: TyreValidationReport,
    moduleName: "Tyre Validation Report",
  },
  {
    auth: true,
    path: "/vehicle-de-enrollment-report",
    main: VehicleDeEnrollmentReport,
    moduleName: "Vehicle De-Enrolment Report",
  },
  {
    auth: true,
    path: "/onwheeldetails",
    main: OnWheelStencils,
    moduleName: "On Wheel Stencil Details",
  },
  {
    auth: true,
    path: "/vehicle-make-master",
    main: VehicleMakeMaster,
    moduleName: "Vehicle Make",
  },
  {
    auth: true,
    path: "/product-master",
    main: withMasterRouteGuard(ProductMaster),
    moduleName: "Product Master",
  },
  {
    auth: true,
    path: "/size-master",
    main: withMasterRouteGuard(SizeMaster),
    moduleName: "Size Master (Retread NSD)",
  },
  {
    auth: true,
    path: "/vendor-master",
    main: withMasterRouteGuard(VendorMaster),
    moduleName: "Vendor Master",
  },
  {
    auth: true,
    path: "/company-master",
    main: withMasterRouteGuard(CompanyMaster),
    moduleName: "Company Master",
  },
  {
    auth: true,
    path: "/stencils",
    main: AllStencils,
    moduleName: "All Stencils",
  },
  {
    auth: true,
    path: "/daily-stencil-details",
    main: DailyStencilDetails,
    moduleName: "Fleet Stock Summary",
  },
  {
    auth: true,
    path: "/daily-inspection-report",
    main: DailyInspectionReport,
    moduleName: "Fitment Report",
  },
  {
    auth: true,
    path: "/daily-fmgrn-report",
    main: DailyFMGrnReport,
    moduleName: "GRN Report",
  },
  {
    auth: true,
    path: "/stencils",
    main: AllStencils,
    moduleName: "All Stencils",
  },
  {
    auth: true,
    path: "/dtp-points",
    main: withMasterRouteGuard(DTPDiscussionPoints),
    moduleName: "DTP Discussion Points",
  },
  {
    auth: true,
    path: "/training-materials",
    main: withMasterRouteGuard(TrainingMaterial),
    moduleName: "Training Materials",
  },
  {
    auth: true,
    path: "/dtp-planning",
    main: DTPPlanning,
    moduleName: "DTP Planning",
  },
  {
    auth: true,
    path: "/manage-dtp",
    main: ManageDTP,
    moduleName: "Manage DTP",
  },
  {
    auth: true,
    path: "/fleets",
    main: AgreedCPKM,
    moduleName: "Fleet Master",
  },
  {
    auth: true,
    path: "/fleet-hub-mapping-master",
    main: withMasterRouteGuard(FleetHubMappingMaster),
    moduleName: "Fleet Hub Mapping Master",
  },

  {
    auth: true,
    path: "/material-master",
    main: withMasterRouteGuard(MaterialMaster),
    moduleName: "Material Master",
  },

  {
    auth: true,
    path: "alignmentPending",
    main: AlignmentPending,
    moduleName: "Alignment Pending",
  },
  {
    auth: true,
    path: "rotationPending",
    main: RotationPending,
    moduleName: "Rotation Pending",
  },
  {
    auth: true,
    path: "dailyTyreReplacement",
    main: DailyTyreReplacement,
    moduleName: "Daily Tyre Replacement",
  },
  {
    auth: true,
    path: "grnPendingReport",
    main: GrnPendingReport,
    moduleName: "GRN Pending Report",
  },
  {
    auth: true,
    path: "batchWiseReport",
    main: BatchWiseReport,
    moduleName: "Batch Wise Report",
  },
  {
    auth: true,
    path: "/mechanical-issue-report",
    main: MechanicalIssueReport,
    moduleName: "Mechanical Issue Report",
  },
  {
    auth: true,
    path: "/sync-masters",
    main: withMasterRouteGuard(SyncMaster),
    moduleName: "Sync Masters",
  },
  {
    auth: false,
    path: "/privacy-policy",
    main: PrivacyPolicy,
    moduleName: "Privacy Policy",
  },
  {
    auth: false,
    path: "/disclaimer",
    main: Disclaimer,
    moduleName: "Disclaimer",
  },
  {
    auth: false,
    path: "*",
    main: NotFoundPage,
    moduleName: "Not Found",
  },
];

export default pages;

/*
FR-H2075
*/
